<template>
  <div class="luck-rank">
    <div class="radio-group">
      <el-radio-group v-model="typeValue" @input="checkType">
        <el-radio-button label="1">{{$t('components_voiceroom_component_rank_luck_rank_1896')}}</el-radio-button>
        <el-radio-button label="2">{{$t('components_voiceroom_component_rank_luck_rank_1897')}}</el-radio-button>
        <el-radio-button label="3">{{$t('components_voiceroom_component_rank_luck_rank_1898')}}</el-radio-button>
        <el-radio-button label="4">{{$t('components_voiceroom_component_rank_luck_rank_1899')}}</el-radio-button>
      </el-radio-group>
    </div>
    <div class="list-box" v-loadMore="getList">
      <div
        class="item"
        v-for="(item, index) of list"
        :key="index"
        @click="toPlayerDetail(item.userUuid)"
      >
        <div class="left">
          <img
            :src="$util.setImageSize(item.avatarUrl, 100, 100)"
            :alt="$t('components_voiceroom_component_rank_charm_rank_1891')"
            class="head-portrait"
          />
          <div class="top">
            <span class="user-name">{{ item.userNickname }}</span>
            <div class="message">
              <span>{{ item.isReceive ? $t('components_voiceroom_component_chat_message_1843') : $t('components_voiceroom_component_rank_luck_rank_1900') }}</span>
              <span class="nick-name">{{ item.boxName }}</span>
              <span>×</span>
              <span class="number">{{ item.boxTotal }}</span>
              <span>{{$t('components_voiceroom_component_chat_message_1845')}}</span>
              <span class="nick-name">{{ item.giftName }}</span>
              <span>×</span>
              <span class="number">{{ item.giftTotal }}</span>
            </div>
          </div>
        </div>
        <div class="right">
          <span class="scroe">{{ item.rankingScore }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVoiceRoomLuckRank } from '@/api/voice-room';

export default {
  name: 'LuckRank',
  data() {
    return {
      list: [],
      typeValue: '4',
      pageIndex: 0,
      pageTotal: null,
      loading: false,
      timeout: null
    };
  },
  props: {
    roomUid: {
      type: String
    }
  },
  watch: {},
  computed: {},
  methods: {
    async getList() {
      console.log('getLIst');
      if (this.loading) {
        return;
      }
      try {
        if (this.pageIndex === 0 || this.list.length < this.pageTotal) {
          this.pageIndex += 1;
          this.loading = true;
          console.log('luck-rank');

          const { data } = await getVoiceRoomLuckRank({
            pageIndex: this.pageIndex,
            pageSize: 15,
            roomUid: this.roomUid,
            type: this.typeValue
          });
          if (!(data && data.pageContent && data.pageContent.length)) {
            this.list = this.list || [];
            this.loading = false;
            return;
          }
          this.list = this.list.concat(data.pageContent);
          this.pageTotal = data.totalRemain;
          this.loading = false;
        }
      } catch (error) {
        console.log(error);
        this.pageIndex -= 1;
        this.loading = false;
      }
    },
    checkType(nVal) {
      this.typeValue = nVal;
      this.initGetList();
    },
    initGetList() {
      if (this.loading) {
        if (this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }
        this.timeout = setTimeout(() => {
          this.initGetList();
        }, 15000);
      } else {
        this.pageIndex = 0;
        this.list = [];
        this.getList();
      }
    }
  },
  destroyed() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }
};
</script>
<style lang="scss" scoped>
.luck-rank {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .radio-group {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    margin-top: 16px;
  }
  .list-box {
    height: 1px;
    flex: auto;
    padding-top: 32px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }
    .item {
      display: flex;
      align-items: center;
      padding: 12px 20px;
      justify-content: space-between;
    }
    .nick-name {
      color: #faebb4;
    }
    .number {
      color: #cd2727;
    }

    .left {
      display: flex;
      align-items: center;
      .head-portrait {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 11px;
      }
      .user-name {
        font-size: 12px;
      }
      .message {
        font-size: 12px;
      }
    }
    .scroe {
      font-size: 14px;
      color: #de1ae2;
    }
  }
  /deep/ .el-radio-button {
    &.is-active {
      .el-radio-button__inner {
        border-radius: 42px;
        background: #f62485;
      }
    }
    .el-radio-button__inner {
      background: rgba(255, 255, 255, 0.05);
      border: none !important;
      box-shadow: none !important;
    }
    &:first-child {
      .el-radio-button__inner {
        border-radius: 42px 0 0 42px;
      }
    }
    &:last-child {
      .el-radio-button__inner {
        border-radius: 0 42px 42px 0;
      }
    }
  }
}
</style>
